import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
// import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useUsersList() {
  // Use toast
  const toast = Vue.$toast;
  // console.log("toast:", toast);

  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'project', label: 'Proje', sortable: true },
    { key: 'queue_name', label: 'Kuyruk Adı', sortable: true },
    { key: 'profile', label: 'Profil', sortable: true },
    { key: 'queue_number', label: 'Kuyruk Numarası', sortable: true },
    { key: 'queue_strat', label: 'Kuyruk Stratejisi', sortable: true },
    { key: 'actions', label: 'Aksiyonlar', sortable: false },
  ]
  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
    refetchData()
  })

  const fetchData = (ctx, callback) => {
    return [
      {
        id: 1,
        project: 'Proje2',
        queue_name: 'Deneme',
        profile: 'Admin',
        queue_number: '123',
        queue_strat: 'Stra2',
        search: 'Manual',
        agentTimeout: 10,
        queueWrapupTime: 10,
        queueAnnounceFrequency: 5,
        queueAnnounceHoldTime: "Evet",
        queueAnnouncePosition: "Hayır",
        queueQueueHoldTime: 10,
        queueMaxlen: 10,
        queueMemberDelay: 1,
        queuePenaltyMembersLimit: 5,
        queuePeriodicAnnounceFrequency: 5,
        queueRetry: 0,
        queueServiceLevel: 60,
        queueMusicOnHold: true,

      },
      {
        id: 2,
        project: 'Abc',
        queue_name: 'Deneme2',
        profile: 'Author',
        queue_number: '123',
        queue_strat: 'Stra1',
        search: 'Dialer',
        agentTimeout: 10,
        queueWrapupTime: 10,
        queueAnnounceFrequency: 3,
        queueAnnounceHoldTime: "Hayır",
        queueAnnouncePosition: "Hayır",
        queueQueueHoldTime: 10,
        queueMaxlen: 10,
        queueMemberDelay: 2,
        queuePenaltyMembersLimit: 5,
        queuePeriodicAnnounceFrequency: 5,
        queueRetry: 1,
        queueServiceLevel: 60,
        queueMusicOnHold: true,

      }
    ];
    store
      .dispatch('app-user/fetchData', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        role: roleFilter.value,
        plan: planFilter.value,
        status: statusFilter.value,
      })
      .then(response => {
        const { users, total } = response.data

        callback(users)
        totalUsers.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === 'pending') return 'warning'
    if (status === 'active') return 'success'
    if (status === 'inactive') return 'secondary'
    return 'primary'
  }

  return {
    fetchData,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
  }
}
